namespace Portico.Models.Pdf {

    export class PdfContent {
        public page: number;
        public content: string;
        public font: string;
        public size: number;
        public style: XFontStyle;
        public color: string;
        public point: Point;

        constructor() {
            this.style = XFontStyle.Regular
            this.size = 16;
            this.point = new Point();
            this.font = 'Arial';
            this.color = '000000';
            this.page = 0;
            this.content = null;
        }
    }
}